import { styled } from '@linaria/react';

import { uiToken } from '~/shared/constants/uiToken';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Header = styled.div`
  padding: 11px 16px;
  width: 100%;
  background-color: ${uiToken.color.background.secondary};
  border-bottom: 1px solid ${uiToken.color.border.default};
  border-top: 1px solid ${uiToken.color.border.default};
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  width: 100%;
`;
